export default __webpack_public_path__ + "static/media/紫玫瑰.9c09324a.svg";